module.exports = __webpack_public_path__ + "static/media/contact.66cb7a04.svg";